/* Lichcards — conditie-uitleg bij de variantkiezer van losse kaarten.
   Hoort bij snippets/lichcards-condition-info.liquid.
   Leest de gekozen conditie uit Ella's [data-selected-value] en werkt de regel
   onder de keuze plus de markering in het paneel bij. Geen afhankelijkheden. */
(function () {
  if (window.lcConditionInfoLoaded) return;
  window.lcConditionInfoLoaded = true;

  function norm(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function customerCondition(value) {
    var labels = {
      good: 'Slightly Played'
    };
    return labels[norm(value)] || (value || '').replace(/\s+/g, ' ').trim();
  }

  function LcConditionInfoClass() {
    return class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.scope = this.closest('.variant-option') || this.parentElement || this;
        this.btn = this.scope.querySelector('.lc-cond-btn');
        this.line = this.querySelector('[data-lc-cond-line]');
        this.lineText = this.querySelector('[data-lc-cond-line-text]');
        this.valueEl = this.scope.querySelector('[data-selected-value]');
        this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-cond]'));

        this._onBtnClick = function (event) {
          // De knop staat in een <label>/<legend>; zonder dit activeert de klik de keuze.
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        }.bind(this);

        this._onDocClick = function (event) {
          if (!this.classList.contains('is-open')) return;
          if (this.contains(event.target)) return;
          if (this.btn && this.btn.contains(event.target)) return;
          this.close();
        }.bind(this);

        this._onKeydown = function (event) {
          if (event.key !== 'Escape') return;
          if (!this.classList.contains('is-open')) return;
          this.close();
          if (this.btn) this.btn.focus();
        }.bind(this);

        this._onChange = this.sync.bind(this);

        if (this.btn) this.btn.addEventListener('click', this._onBtnClick);

        var closeBtn = this.querySelector('[data-lc-cond-close]');
        if (closeBtn) {
          closeBtn.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              this.close();
              if (this.btn) this.btn.focus();
            }.bind(this)
          );
        }

        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKeydown);
        this.scope.addEventListener('change', this._onChange);

        // Ella schrijft de gekozen waarde in [data-selected-value] na elke variantwissel.
        if (this.valueEl && 'MutationObserver' in window) {
          this._observer = new MutationObserver(this._onChange);
          this._observer.observe(this.valueEl, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKeydown);
        if (this.scope) this.scope.removeEventListener('change', this._onChange);
        if (this._observer) this._observer.disconnect();
        this._ready = false;
      }

      sync() {
        var currentText = this.valueEl ? this.valueEl.textContent : '';
        var customerText = customerCondition(currentText);
        var value = norm(customerText);
        var match = null;

        // Ella vult na een variantwissel de ruwe PowerTools-waarde opnieuw in.
        // Zet alleen de zichtbare tekst terug; de inputwaarde blijft ongewijzigd.
        if (this.valueEl && norm(currentText) !== value) {
          this.valueEl.textContent = customerText;
        }

        this.rows.forEach(function (row) {
          var isCurrent = row.getAttribute('data-cond') === value;
          row.classList.toggle('is-current', isCurrent);
          if (isCurrent) match = row;
        });

        if (!this.line || !this.lineText) return;

        if (match) {
          this.lineText.textContent = match.getAttribute('data-short') || '';
          this.line.classList.add('is-visible');
        } else {
          // Onbekende waarde (bijvoorbeeld een gegradeerde kaart): geen regel verzinnen.
          this.lineText.textContent = '';
          this.line.classList.remove('is-visible');
        }
      }

      toggle() {
        if (this.classList.contains('is-open')) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.classList.add('is-open');
        if (this.btn) this.btn.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.classList.remove('is-open');
        if (this.btn) this.btn.setAttribute('aria-expanded', 'false');
      }
    };
  }

  if (!customElements.get('lc-condition-info')) {
    customElements.define('lc-condition-info', LcConditionInfoClass());
  }
})();
